/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

import { useLocation } from "@reach/router"

function Seo({ description, image, lang, meta, title }) {
  const location = useLocation()

  const query = useStaticQuery(
    graphql`
      query {
        realEstate {
          seo {
            title
            description
            author
            image
            siteUrl
            share_image
          }
        }
      }
    `
  )

  const metaDescription = description || query.realEstate.seo.description
  const defaultTitle = query.realEstate.seo?.title
  const defaultImage = image ? image : query.realEstate.seo?.share_image // Modificar

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={defaultTitle}
      titleTemplate={defaultTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: defaultTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:image`,
          content: defaultImage,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: query.realEstate.seo?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: "author",
          content: "MediaCore®",
        },
        {
          name: "copyright",
          content: "MediaCore®",
        },
        {
          name: "publisher",
          content: "MediaCore®",
        },
        {
          name: "robots",
          content: "index,follow",
        },
        {
          name: "googlebot",
          content: "index,follow",
        },
      ].concat(meta)}
    />
    // <link rel="canonical" href={query.realEstate.seo.siteUrl} />
    // <meta property="og:image:type" content="image/jpg" />
    // <meta property="og:image" content={defaultImage} />
    // <meta property="og:title" content={defaultTitle} />
    // </Helmet>
  )
}

Seo.defaultProps = {
  lang: `es`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo
